var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-tree-select',{staticStyle:{"width":"100%"},attrs:{"tree-data":_vm.actorOptions,"treeNodeFilterProp":"title","tree-checkable":"","show-checked-strategy":_vm.SHOW_PARENT,"search-placeholder":"Auswahl"},model:{value:(_vm.actor),callback:function ($$v) {_vm.actor=$$v},expression:"actor"}})
}
var staticRenderFns = []

export { render, staticRenderFns }